// ProtectedRoute.jsx
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../../../firebase";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const [user, setUser] = useState(undefined);

  let adminUsers = process.env.REACT_APP_ADMIN_USERS

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setUser(user);
    });
    return () => unsub();
  }, []);

  if (user === undefined) return null; // loading
  if (!user && !adminUsers.includes(user.email)) return <Navigate to="/" replace />;

  return children;
}
